module.exports = __webpack_public_path__ + "img/c8bc423e7e83ccf7350fc1d501760bed.ae302038.png";